'use client'

import CloseIcon from '@/icons/CloseIcon'
import SearchIcon from '@/icons/SearchIcon'
import { cn } from '@/lib/utils'
import { ChangeEvent, useCallback, useState } from 'react'

type SearchInputProps = {
  className?: string
  value?: string
  onChange?: (value: string) => void
}
export default function SearchInput({ className = '', value, onChange }: SearchInputProps) {
  const [isFocus, setIsFocus] = useState<boolean>(false)

  const handleFocus = useCallback(() => {
    setIsFocus(true)
  }, [])

  const handleBlur = useCallback(() => {
    setIsFocus(false)
  }, [])

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e.target.value)
    },
    [onChange]
  )

  const handleClear = useCallback(() => {
    onChange && onChange('')
  }, [onChange])

  return (
    <div
      className={cn(
        'font-space-grotesk flex h-[40px] items-center gap-2 rounded-2xl border border-black/10 bg-white/80 px-4 text-base shadow-sm backdrop-blur-xl transition',
        { 'border-gray-300': isFocus },
        className
      )}
    >
      <span className="flex h-6 w-6 items-center justify-center">
        <SearchIcon className={cn('text-gray-900/60')} />
      </span>
      <input
        className={cn(
          'font-space-grotesk flex-grow truncate bg-transparent text-sm font-medium outline-none placeholder:font-medium',
          value ? 'text-gray-900' : 'text-white',
          'placeholder:text-gray-400'
        )}
        placeholder="Search"
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        aria-label="Search"
      />
      {value && (
        <button
          type="button"
          onClick={handleClear}
          className="flex h-6 w-6 items-center justify-center rounded hover:bg-white/20"
          aria-label="Clear search"
        >
          <CloseIcon className="h-4 w-4 text-gray-900/60" />
        </button>
      )}
    </div>
  )
}
